import "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "../ap2/config.js";
import "../ap2/state.js";
import "./config.js";
import { retrieveLegacyRedirectRoute, retrieveLegacyMethod, retrieveLegacyPersistentLogin, saveAuthFlow, removeLegacyAuthFlow } from "./persistence.js";
import "@crystal/config";
import "../config/source-ids.js";
import { Touchpoint } from "../config/touchpoints.js";
import "../config/presets.js";
const migrateLegacyAuthFlow = () => {
  const target = retrieveLegacyRedirectRoute();
  if (target) {
    const method = retrieveLegacyMethod();
    const persistentLogin = retrieveLegacyPersistentLogin();
    saveAuthFlow({
      method: method || "social-login",
      provider: method === "kmc" ? "kmc" : "facebook",
      authContext: {
        persistentLogin
      },
      pageContext: {
        touchpoint: Touchpoint.Unknown,
        originRoute: target
      }
    });
    removeLegacyAuthFlow();
  }
};
export {
  migrateLegacyAuthFlow
};
//# sourceMappingURL=legacy-auth-flow.js.map
